export const CONTENT_FOLDER = "/content/commerce";
export const NEW_CONTENT_FOLDER = "/loja";
export const DEFAULT_EXTENSION = ".html";

function removeContentStructure(path: string) {
  if (path.startsWith(CONTENT_FOLDER) && !isAuthor()) {
    const newPath = NEW_CONTENT_FOLDER + path.substring(CONTENT_FOLDER.length);
    return newPath;
  }

  return path + DEFAULT_EXTENSION;
}
export function isAuthor() {
  const urlRegex = /(editor\.html|author|localhost:4502|localhost:4200)/i;
  return urlRegex.test(window.location.href);
}

export const rewritePathfield = (path: string) => removeContentStructure(path);